/** @jsxImportSource @emotion/react */
import {useEffect} from 'react';

import {css} from '@emotion/react';
import PropTypes from 'prop-types';
import {useDispatch} from 'react-redux';

import * as setupActions from '@/actions/setupActions';
import {fontSize} from '@/constants/appStyle';
import {FONT_SIZE} from '@/constants/pcConstAppData';
import * as PCConstAppData from '@/constants/pcConstAppData';
import {CycleHistoryContextProvider} from '@/contexts/CycleHistoryContext';
import {CycleHistoryDetailContextProvider} from '@/contexts/CycleHistoryDetailContext';

import CycleHistoryBottomMenuContainer from './CycleHistoryBottomMenuContainer';
import CycleHistoryPageComponent from './CycleHistoryPageComponent';

// import { UpdateSideMenuVisibility } from "../../../Store/actions/RemoteUiAction";
import './CycleHistoryPage.scss';

function CycleHistoryPage(props) {
  // TODO isRemoteView it may good option to store it as an application context or application store
  const {isRemoteView} = props;
  const dispatch = useDispatch();

  useEffect(() => {
    // dispatch(UpdateSideMenuVisibility(true));
    dispatch(setupActions.updateActiveMenu(PCConstAppData.CYCLE_HISTORY));
  }, []);

  const CycleHistoryStyle = css({
    fontSize: parseInt(window.localStorage.getItem(FONT_SIZE), 10) || fontSize,
    height: '100%',
  });

  return (
    <CycleHistoryContextProvider isRemoteView={isRemoteView}>
      <CycleHistoryDetailContextProvider>
        <div
          css={CycleHistoryStyle}
          className={isRemoteView ? 'remoteViewProfieHistory' : ''}
        >
          <CycleHistoryPageComponent />
          <CycleHistoryBottomMenuContainer isRemoteView={isRemoteView} />
        </div>
      </CycleHistoryDetailContextProvider>
    </CycleHistoryContextProvider>
  );
}
CycleHistoryPage.propTypes = {
  isRemoteView: PropTypes.bool,
};
CycleHistoryPage.defaultProps = {
  isRemoteView: false,
};
export default CycleHistoryPage;
